/**
 * Age Consent Checkbox Validation
 * Ensures the age consent checkbox is checked before form submission
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all forms with age consent checkboxes
  const formsWithAgeConsent = document.querySelectorAll('form:has(.age-consent-wrapper)');
  
  formsWithAgeConsent.forEach(function(form) {
    form.addEventListener('submit', function(event) {
      // Find the age consent checkbox within this form
      const ageConsentCheckbox = form.querySelector('.age-consent-wrapper input[type="checkbox"]');
      
      if (ageConsentCheckbox && !ageConsentCheckbox.checked) {
        event.preventDefault();
        
        // Add visual feedback
        const checkboxWrapper = ageConsentCheckbox.closest('.age-consent-wrapper');
        if (checkboxWrapper) {
          checkboxWrapper.style.outline = '2px solid red';
          checkboxWrapper.style.borderRadius = '4px';
          checkboxWrapper.style.padding = '5px';
          
          // Show error message
          let errorMessage = checkboxWrapper.querySelector('.age-consent-error');
          if (!errorMessage) {
            errorMessage = document.createElement('div');
            errorMessage.className = 'age-consent-error';
            errorMessage.style.color = 'red';
            errorMessage.style.fontSize = '12px';
            errorMessage.style.marginTop = '5px';
            errorMessage.textContent = 'You must confirm that you are at least 18 years of age.';
            checkboxWrapper.appendChild(errorMessage);
          }
          
          // Scroll to checkbox
          checkboxWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        
        // Focus on the checkbox
        ageConsentCheckbox.focus();
        
        return false;
      }
    });
    
    // Remove error styling when checkbox is checked
    const ageConsentCheckbox = form.querySelector('.age-consent-wrapper input[type="checkbox"]');
    if (ageConsentCheckbox) {
      ageConsentCheckbox.addEventListener('change', function() {
        if (this.checked) {
          const checkboxWrapper = this.closest('.age-consent-wrapper');
          if (checkboxWrapper) {
            checkboxWrapper.style.outline = 'none';
            checkboxWrapper.style.padding = '0';
            
            const errorMessage = checkboxWrapper.querySelector('.age-consent-error');
            if (errorMessage) {
              errorMessage.remove();
            }
          }
        }
      });
    }
  });
});

